
import { VideoCameraIcon } from '@heroicons/react/24/outline';

const SearchForVideo = () => {
  return (
    <div>
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
        <VideoCameraIcon className="h-16 w-16 text-blue-500 mx-auto mb-4" aria-hidden="true" />
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Start Searching for a Video</h2>
        <p className="text-gray-600">Use the search bar to look for a video that matches your interests.</p>
      </div>
    </div>
  );
};

export default SearchForVideo;
